import { PayloadAction } from '@reduxjs/toolkit';
import { ShipmentHistoryState } from './Type';
import { SuccessPayload } from '../../../types';

function pending(state: ShipmentHistoryState) {
  state.loading = true;
  state.shipmentCancelled = false;
  state.bulkStatusUploaded = false;
}

function success(state: ShipmentHistoryState) {
  state.loading = false;
}

function getShipmentListFulfilled(state: ShipmentHistoryState, data: { payload: any }) {
  const payloadData = data?.payload?.data || data?.payload || {};
  const shipmentResult =
    payloadData.shipmentResult ||
    payloadData.list ||
    payloadData.lists ||
    payloadData.shipments ||
    (Array.isArray(payloadData) ? payloadData : []);
  const totalCount =
    typeof payloadData.totalCount === 'number'
      ? payloadData.totalCount
      : typeof payloadData.count === 'number'
      ? payloadData.count
      : Array.isArray(shipmentResult)
      ? shipmentResult.length
      : 0;
  const currentPage = payloadData.currentPage || state.data.currentPage || 1;
  const perPage = payloadData.perPage || state.data.perPage || 10;

  state.loading = false;
  state.data.list = Array.isArray(shipmentResult) ? shipmentResult : [];
  state.data.totalCount = totalCount;
  state.data.currentPage = currentPage;
  state.data.perPage = perPage;
}

function cancelShipmentFulfilled(state: ShipmentHistoryState, action: PayloadAction<SuccessPayload>) {
  state.loading = false;
  state.success = action?.payload?.msg;
  state.shipmentCancelled = true;
}

function UpdateShipmentStatusFulfilled(state: ShipmentHistoryState, action: PayloadAction<SuccessPayload>) {
  state.loading = false;
  state.success = action?.payload?.msg;
}

function bulkStatusUpdateFulfilled(state: ShipmentHistoryState) {
  state.loading = false;
  state.bulkStatusUploaded = true;
}
function bulkPaymentStatusUpdateFulfilled(state: ShipmentHistoryState) {
  state.loading = false;
  state.isBulkPaymentStatusUpdate = true;
}

function rejected(state: ShipmentHistoryState) {
  state.loading = false;
  state.error = { msg: 'error', isError: true };
}

export {
  pending,
  success,
  getShipmentListFulfilled,
  cancelShipmentFulfilled,
  UpdateShipmentStatusFulfilled,
  rejected,
  bulkStatusUpdateFulfilled,
  bulkPaymentStatusUpdateFulfilled,
};
